export default function Chips({ tags }) {
  return (
    <div className="d-flex flex-wrap">
      {tags.map((tag, index) => {
        return (
          <div className="d-inline-block mb-1" key={index}>
            <small className="px-2 py-1 me-1 border rounded text-muted user-select-none">
              {tag}
            </small>
          </div>
        )
      })}
    </div>
  )
}
